import * as generic from '@/store/generic/mutations/result-status.js'

export function clearError(state, payload) {
  generic.clearError(state, payload)
}

export function setError(state, payload) {
  generic.setError(state, payload)
}

export function setSuccess(state, payload) {
  generic.setSuccess(state, payload)
}

export function setProcessing(state, payload) {
  generic.setProcessing(state, payload)
}

export function setSampleMessages(state, payload) {
  state.sampleMessages = payload || []
}

export function addSampleMessage(state, payload) {
  if (!payload) return

  const existingIndex = state.sampleMessages.findIndex(message => message.id === payload.id)
  if (existingIndex >= 0) {
    state.sampleMessages.splice(existingIndex, 1, payload)
  } else {
    state.sampleMessages.unshift(payload)
  }
}

export function setSampleSubscription(state, payload) {
  state.sampleSubscription = payload
}

export function clearSampleSubscription(state) {
  state.sampleSubscription = null
}
